import React, { useState, useEffect } from 'react'
import JpmcExpenseTable from '../JpmcDashboard/JpmcExpenseTable'
import api from '../../utils/api'
import AddExpenses from './AddExpenses'
import Spinner from '../../common/Spinner/Spinner'
import { toast } from 'react-toastify'
import { getUser } from '../../utils/localStorage'

const JpmcExpenseDashboardContainer = () => {
  const [jpmcExpsData, setJpmcExpsData] = useState([])
  const [isAddExpenseClicked, setIsAddExpenseClicked] = useState(false)
  const [loading, setLoading] = useState(false)

  const [expenseFields, setExpenseFields] = useState({
    sPrg_Director: 0,
    sPrg_Mngr: 0,
    sPrg_Exe: 0,
    sMobilization_Communication: 0,
    sGroup_Knowledge_Session: 0,
    sGroup_Expert_Consultation: 0,
    sAccess_to_Market: 0,
    sAccess_to_Compliance: 0,
    sAccess_to_Finance_BLRP: 0,
    sTravel_Expenses: 0,
    sEquipment_Supplies: 0,
    sDeAsra_Portal: 0,
    sDeAsra_Dashboard_Convenio: 0,
    sUpgrowth: 0,
    sGIPE_CEED_Research_Expense: 0,
  })

  const [monthOptions, setMonthOptions] = useState([
    {
      value: 1,
      label: "January"
    },
    {
      value: 2,
      label: "February"
    },
    {
      value: 3,
      label: "March"
    },
    {
      value: 4,
      label: "April"
    },
    {
      value: 5,
      label: "May"
    },
    {
      value: 6,
      label: "June"
    },
    {
      value: 7,
      label: "July"
    },
    {
      value: 8,
      label: "August"
    },
    {
      value: 9,
      label: "September"
    },
    {
      value: 10,
      label: "October"
    },
    {
      value: 11,
      label: "November"
    },
    {
      value: 12,
      label: "December"
    },
  ])

  const [selectedMonth, setSelectedMonth] = useState([])

  const [yearOptions, setYearOptions] = useState([
    {
      value: 2024,
      label: 2024
    },
    {
      value: 2025,
      label: 2025
    },
    {
      value: 2026,
      label: 2026
    },
  ])

  const [selectedYear, setSelectedYear] = useState([])

  const handleChange = (name, value) => {
    const updated = { ...expenseFields, [name]: value }
    setExpenseFields(updated)

    const {
      sPrg_Director,
      sPrg_Mngr,
      sPrg_Exe,
      sMobilization_Communication,
      sGroup_Knowledge_Session,
      sGroup_Expert_Consultation,
      sAccess_to_Market,
      sAccess_to_Compliance,
      sAccess_to_Finance_BLRP,
      sTravel_Expenses,
      sEquipment_Supplies,
      sDeAsra_Portal,
      sDeAsra_Dashboard_Convenio,
      sUpgrowth,
      sGIPE_CEED_Research_Expense,
    } = updated
  }

  const onMonthChange = (option) => {
    setSelectedMonth(option)
  }

  const onYearChange = (option) => {
    setSelectedYear(option)
  }

  const getTableData = () => {
    setLoading(true)
    const { tempJpmcExpenseData } = api.jpmcExpenseTableData()
      .then(({ data }) => {
        console.log("Expense Data", data)
        setLoading(false)
        setJpmcExpsData(data.data)
      })
  }

  useEffect(() => {
    getTableData()
  }, [])

  const onAddBtnClick = () => {
    setIsAddExpenseClicked(true)
  }

  const onBackClick = () => {
    setIsAddExpenseClicked(false)
    setExpenseFields({
      sPrg_Director: 0,
      sPrg_Mngr: 0,
      sPrg_Exe: 0,
      sMobilization_Communication: 0,
      sGroup_Knowledge_Session: 0,
      sGroup_Expert_Consultation: 0,
      sAccess_to_Market: 0,
      sAccess_to_Compliance: 0,
      sAccess_to_Finance_BLRP: 0,
      sTravel_Expenses: 0,
      sEquipment_Supplies: 0,
      sDeAsra_Portal: 0,
      sDeAsra_Dashboard_Convenio: 0,
      sUpgrowth: 0,
      sGIPE_CEED_Research_Expense: 0,
    })
    setSelectedMonth([])
    setSelectedYear([])
  }

  const onSaveClick = () => {
    try{
      if (!selectedMonth.value) {
        toast("Month is required", {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
        })
      } else if (!selectedYear.value) {
        toast("Year is required", {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
        })
      } else {
        let payload = {
          nYear: selectedYear.value,
          nMonth: selectedMonth.value,
          sPrg_Director: expenseFields.sPrg_Director || 0,
          sPrg_Mngr: expenseFields.sPrg_Mngr || 0,
          sPrg_Exe: expenseFields.sPrg_Exe || 0,
          sMobilization_Communication: expenseFields.sMobilization_Communication || 0,
          sGroup_Knowledge_Session: expenseFields.sGroup_Knowledge_Session || 0,
          sGroup_Expert_Consultation: expenseFields.sGroup_Expert_Consultation || 0,
          sAccess_to_Market: expenseFields.sAccess_to_Market || 0,
          sAccess_to_Compliance: expenseFields.sAccess_to_Compliance || 0,
          sAccess_to_Finance_BLRP: expenseFields.sAccess_to_Finance_BLRP || 0,
          sTravel_Expenses: expenseFields.sTravel_Expenses || 0,
          sEquipment_Supplies: expenseFields.sEquipment_Supplies || 0,
          sDeAsra_Portal: expenseFields.sDeAsra_Portal || 0,
          sDeAsra_Dashboard_Convenio: expenseFields.sDeAsra_Dashboard_Convenio || 0,
          sUpgrowth: expenseFields.sUpgrowth || 0,
          sGIPE_CEED_Research_Expense: expenseFields.sGIPE_CEED_Research_Expense || 0,
        }
        setLoading(true)
        const { tempAddExpData } = api.jpmcAddExpenseApi(payload)
          .then(({ data }) => {
            console.log("Data", data)
            setLoading(false)
            toast("Expense Added Successfully", {
              autoClose: 5000,
              type: toast.TYPE.SUCCESS,
            })
            setExpenseFields({
              sPrg_Director: 0,
              sPrg_Mngr: 0,
              sPrg_Exe: 0,
              sMobilization_Communication: 0,
              sGroup_Knowledge_Session: 0,
              sGroup_Expert_Consultation: 0,
              sAccess_to_Market: 0,
              sAccess_to_Compliance: 0,
              sAccess_to_Finance_BLRP: 0,
              sTravel_Expenses: 0,
              sEquipment_Supplies: 0,
              sDeAsra_Portal: 0,
              sDeAsra_Dashboard_Convenio: 0,
              sUpgrowth: 0,
              sGIPE_CEED_Research_Expense: 0,
            })
            setSelectedMonth([])
            setSelectedYear([])
            setIsAddExpenseClicked(false)
            getTableData()
          }) .catch((error) => {
            setLoading(false);
            if (error.response) {
              console.log("Error Response Data:", error.response.data);
              toast(error.response.data.message, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            } 
          });
      }
    } catch (error) {
      toast("Something Went Wrong", {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
      });
  }
    
  }

  const showAddButton = () => {
    const user = getUser()
    if (user.role.includes(14)){
      return true
    } else {
      return false
    }
  }

  return (
    <div className={`${loading && "set-opacity"}`}>
      {loading && <Spinner className="center-screen" />}
      <div className="row mt-2 mb-4">
        <div className="col-md-12">



          {
            isAddExpenseClicked ?
              <AddExpenses
                expenseFields={expenseFields}
                onBackClick={onBackClick}
                handleChange={handleChange}
                onSaveClick={onSaveClick}
                monthOptions={monthOptions}
                onMonthChange={onMonthChange}
                selectedMonth={selectedMonth}
                yearOptions={yearOptions}
                onYearChange={onYearChange}
                selectedYear={selectedYear}
              />
              :
              <>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginLeft:10,
                  marginRight: 10
                }}>
                  <h3 className="spled-colored-label mt-3 mb-3" style={{
                    fontSize: "20px",
                    // textAlign: 'left',
                    // marginLeft: 10
                  }}>JPMC Dashboard Expense Data</h3>
                  {console.log("Show",showAddButton() )}
                  {showAddButton() && <button className='con-btn-filled' onClick={onAddBtnClick}>Add Expense</button>}
                </div>

                <JpmcExpenseTable data={jpmcExpsData} />
              </>

          }


        </div>
      </div>
    </div>
  )
}

export default JpmcExpenseDashboardContainer
